import { useState } from "react";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";

type FilterOption = {
	value: string | number;
	label: string;
};

type LogbookMultiSelectFilterProps = {
	label: string;
	options: Array<FilterOption>;
	selected: Array<string | number>;
	onChange: (values: Array<any>) => void;
	size?: "small" | "medium";
	fullWidth?: boolean;
};

export const MultiSelectFilter = ({ label, options, selected, onChange, size = "small", fullWidth }: LogbookMultiSelectFilterProps) => {
	const [isOpen, setIsOpen] = useState(false);

	const renderValue = (values: Array<string | number>) => {
		if (values.length === 0) return "Todos";
		return options
			.filter((o) => values.includes(o.value))
			.map((o) => o.label)
			.join(", ");
	};

	return (
		<FormControl size={size} fullWidth={fullWidth} sx={fullWidth ? {} : { width: 250, maxWidth: 400 }}>
			<InputLabel>{label}</InputLabel>
			<Select
				multiple
				value={selected}
				label={label}
				onOpen={() => setIsOpen(true)}
				onClose={() => setIsOpen(false)}
				renderValue={renderValue}
				onChange={(e) => onChange(e.target.value as Array<any>)}
				sx={{
					"& .MuiSelect-select": { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", paddingRight: "32px !important" },
				}}
			>
				{options.map((option) => (
					<MenuItem
						key={option.value}
						value={option.value}
						sx={{
							"&.Mui-selected": { backgroundColor: "#df644952" },
							"&.Mui-selected:hover": { backgroundColor: "#df644952" },
							minWidth: 300,
						}}
					>
						<Box display="flex" justifyContent="space-between" flex={1}>
							<Typography variant="body2">{option.label}</Typography>
							{isOpen && (
								<Button
									size="small"
									onClick={(e) => {
										e.stopPropagation();
										onChange([option.value]);
									}}
								>
									Só
								</Button>
							)}
						</Box>
					</MenuItem>
				))}
				<MenuItem>
					<Button
						size="small"
						fullWidth
						color="secondary"
						onClick={(e) => {
							e.stopPropagation();
							onChange([]);
						}}
					>
						Remover Filtro
					</Button>
				</MenuItem>
			</Select>
		</FormControl>
	);
};
